<template>
    <div class="header-margin">
        <div class="container center-items">
            <div class="text-center px-3 mb-4">
                <div class="pt-5">
                    <div v-if="errorCode === 'not_login'" class="text-left">{{ $t('errors.STUDY_NOT_LOGIN') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';

    export default {
        name: 'studies-detail',

        data() {
            return {
                isAuth: false,
                isChild: false,
                errorCode: null
            }
        },

        created() {
            this.isAuth = AuthUtil.isAuth();
            this.errorCode = this.$route.query.code

            let is_child = this.$route.query.is_child;
            if (is_child) {
                this.isChild = is_child;
            }
        }
    }
</script>

<style>
</style>
